import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../../wayfinder'
import packageMethodCd5dd2 from './package'
import domain from './domain'
/**
* @see \App\Http\Controllers\Creator\SendingDomainController::defaults
* @see app/Http/Controllers/Creator/SendingDomainController.php:36
* @route '/app/creator/campaigns-settings/defaults'
*/
export const defaults = (options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: defaults.url(options),
    method: 'put',
})

defaults.definition = {
    methods: ["put"],
    url: '/app/creator/campaigns-settings/defaults',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Creator\SendingDomainController::defaults
* @see app/Http/Controllers/Creator/SendingDomainController.php:36
* @route '/app/creator/campaigns-settings/defaults'
*/
defaults.url = (options?: RouteQueryOptions) => {
    return defaults.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\SendingDomainController::defaults
* @see app/Http/Controllers/Creator/SendingDomainController.php:36
* @route '/app/creator/campaigns-settings/defaults'
*/
defaults.put = (options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: defaults.url(options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Creator\SendingDomainController::defaults
* @see app/Http/Controllers/Creator/SendingDomainController.php:36
* @route '/app/creator/campaigns-settings/defaults'
*/
const defaultsForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: defaults.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\SendingDomainController::defaults
* @see app/Http/Controllers/Creator/SendingDomainController.php:36
* @route '/app/creator/campaigns-settings/defaults'
*/
defaultsForm.put = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: defaults.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

defaults.form = defaultsForm

/**
* @see \App\Http\Controllers\Creator\SendingDomainController::packageMethod
* @see app/Http/Controllers/Creator/SendingDomainController.php:82
* @route '/app/creator/campaigns-settings/package'
*/
export const packageMethod = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: packageMethod.url(options),
    method: 'post',
})

packageMethod.definition = {
    methods: ["post"],
    url: '/app/creator/campaigns-settings/package',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Creator\SendingDomainController::packageMethod
* @see app/Http/Controllers/Creator/SendingDomainController.php:82
* @route '/app/creator/campaigns-settings/package'
*/
packageMethod.url = (options?: RouteQueryOptions) => {
    return packageMethod.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\SendingDomainController::packageMethod
* @see app/Http/Controllers/Creator/SendingDomainController.php:82
* @route '/app/creator/campaigns-settings/package'
*/
packageMethod.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: packageMethod.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\SendingDomainController::packageMethod
* @see app/Http/Controllers/Creator/SendingDomainController.php:82
* @route '/app/creator/campaigns-settings/package'
*/
const packageMethodForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: packageMethod.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\SendingDomainController::packageMethod
* @see app/Http/Controllers/Creator/SendingDomainController.php:82
* @route '/app/creator/campaigns-settings/package'
*/
packageMethodForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: packageMethod.url(options),
    method: 'post',
})

packageMethod.form = packageMethodForm

const settings = {
    defaults: Object.assign(defaults, defaults),
    package: Object.assign(packageMethod, packageMethodCd5dd2),
    domain: Object.assign(domain, domain),
}

export default settings